import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Title from "src/components/Title";
import API from "src/services/api";

const ImageOverviewSite = () => {
  const [data, setData] = useState([]);

  const loadData = async () => {
    const d = await API.getAllSwipeImages();
    if (d.data) {
      setData(d.data);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Alle Bilder</Title>
        </Col>
      </Row>
      <Row>
        {data.map((i) => (
          <Col xs={2} className="add-margin">
            <Link to={`/swipe/${i.swipe_id}`}>
              <img
                src={`${i.urlImage ? i.urlImage : i.url}`}
                style={{ width: "100%" }}
              />
            </Link>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default ImageOverviewSite;
